import React from "react";
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider, useAuth } from "./context/AuthContext";
import Login from "./pages/Login";
import Layout from "./components/Layout";
import NuovoEvento from "./pages/NuovoEvento";
import ListaEventi from "./pages/ListaEventi";
import FormEvento from "./pages/FormEvento";
import Impostazioni from "./pages/Impostazioni";
import Collaboratori from "./pages/Collaboratori";
import Statistiche from "./pages/Statistiche";
import ReportPresenze from "./pages/ReportPresenze";
import Referenti from "./pages/Referenti";
import Log from "./pages/Log";
import AccessiReferenti from "./pages/AccessiReferenti";
import LoginCliente from "./pages/LoginCliente";
import ReportCliente from "./pages/ReportCliente";
import LoginClienteCorso from "./pages/LoginClienteCorso";
import ReportClienteCorso from "./pages/ReportClienteCorso";
import UtilityHub from "./pages/utility/UtilityHub";
import ReportIF from "./pages/utility/ReportIF";
import CorsiList from "./pages/utility/kpiStudenti/CorsiList";
import CorsoDetail from "./pages/utility/kpiStudenti/CorsoDetail";
import LinkOutlook from "./pages/utility/LinkOutlook";

function PrivateRoute({ children }) {
  const { currentUser } = useAuth();
  return currentUser ? (
    <Layout>{children}</Layout>
  ) : (
    <Navigate to="/login" />
  );
}

function App() {
  return (
    <AuthProvider>
      <Router>
        <Routes>
          {/* Rotte pubbliche cliente */}
          <Route path="/accesso/:id" element={<LoginCliente />} />
          <Route path="/report/:id" element={<ReportCliente />} />
          <Route path="/accesso-corso/:corsoId" element={<LoginClienteCorso />} />
          <Route path="/report-corso/:corsoId" element={<ReportClienteCorso />} />

          {/* Rotte private team interno */}
          <Route path="/login" element={<Login />} />
          <Route path="/" element={<PrivateRoute><ListaEventi /></PrivateRoute>} />
          <Route path="/nuovo-evento" element={<PrivateRoute><NuovoEvento /></PrivateRoute>} />
          <Route path="/evento/:id" element={<PrivateRoute><FormEvento /></PrivateRoute>} />
          <Route path="/evento/:id/report-presenze" element={<PrivateRoute><ReportPresenze /></PrivateRoute>} />
          <Route path="/collaboratori" element={<PrivateRoute><Collaboratori /></PrivateRoute>} />
          <Route path="/referenti" element={<PrivateRoute><Referenti /></PrivateRoute>} />
          <Route path="/statistiche" element={<PrivateRoute><Statistiche /></PrivateRoute>} />
          <Route path="/impostazioni" element={<PrivateRoute><Impostazioni /></PrivateRoute>} />
          <Route path="/log" element={<PrivateRoute><Log /></PrivateRoute>} />
          <Route path="/accessi-referenti" element={<PrivateRoute><AccessiReferenti /></PrivateRoute>} />
          <Route path="/utility" element={<PrivateRoute><UtilityHub /></PrivateRoute>} />
          <Route path="/utility/report-if" element={<PrivateRoute><ReportIF /></PrivateRoute>} />
          <Route path="/utility/kpi-studenti" element={<PrivateRoute><CorsiList /></PrivateRoute>} />
          <Route path="/utility/kpi-studenti/:corsoId" element={<PrivateRoute><CorsoDetail /></PrivateRoute>} />
          <Route path="/utility/link-outlook" element={<PrivateRoute><LinkOutlook /></PrivateRoute>} />
        </Routes>
      </Router>
    </AuthProvider>
  );
}

export default App;